import { Typography } from "@mui/material";
import { twMerge } from "tailwind-merge";

const Title = ({ title, className = "" }: { title: string; className?: string }) => {
	const classes = twMerge("!font-montserrat !font-[500] !text-[20px] text-default !p-0", className);
	return <Typography className={classes}>{title}</Typography>;
};

export default Title;
